const pathname = window.location.pathname
const isFramesRoute = pathname === '/frame' || pathname.startsWith('/frame/') || pathname === '/settings/frame' || pathname.startsWith('/settings/frame/')

// Keep the Frames entry point independent from the legacy Look runtime. In
// particular, this prevents Konva, PDF, charts, Home, and Google fonts from
// competing with the first Frames render.
const bootstrap = isFramesRoute
  ? import('@/bootstrap/frames')
  : import('@/bootstrap/legacy')

void bootstrap.then(({ bootstrapApp }) => bootstrapApp())
